import React from "react";
import { Row, Col } from 'antd';
import { TagContainer, TagTitle, TagList } from './styles';

export default ({ data, expand = false }) => {
    function getTagList(application) {
        return (
            <TagList>
                {application.roles.map((role, index) => (
                    <li key={index}>{role.name}</li>
                ))}
            </TagList>
        )
    }

    return (
        <Row align={"top"}>
            {data.map((application, index) => (
                <TagContainer key={index}>
                    <TagTitle key={index}>{application.name}</TagTitle>
                    {expand ? getTagList(application) : null}
                </TagContainer>
            ))}
        </Row>
    )
}